// extracted by mini-css-extract-plugin
module.exports = {"ActualComment":"ActualComment_ActualComment__1behD","ToggleReplies":"ActualComment_ToggleReplies__3A-xI","Replies":"ActualComment_Replies__35IQw"};